export default "__VITE_ASSET__4uWAOloe__"